<template>
  <div
    ref="searchRoot"
    class="content-search">
    <div
      class="content-search__search-button"
      @click="toggleSearch" />

    <div
      ref="searchBody"
      class="content-search__wrapper">
      <label class="content-search__body">
        <input
          ref="searchInput"
          :value="searchValue"
          class="content-search__input"
          type="search"
          inputmode="search"
          placeholder="Search"
          autocomplete="off"
          @focus="showSearch"
          @blur="hideSearch"
          @input="updateSearchValue">
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsSearch',

  props: {
    content: {
      type: Array,
      default: () => [],
    },

    keepOpenOnSearch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hasFocus: false,
      searchValue: '',
    };
  },

  watch: {
    searchValue(newVal) {
      this.$emit('search', newVal);
    },
  },

  methods: {
    showSearch(event) {
      const { searchRoot, searchBody } = this.$refs;
      searchBody.addEventListener(
        'transitionend',
        () => {
          if (event.target === document.activeElement) {
            this.hasFocus = true;
            searchRoot.classList.add('content-search--active');
          }
        },
        { once: true },
      );
    },

    hideSearch() {
      if (!this.keepOpenOnSearch || this.searchValue.trim() === '') {
        this.hasFocus = false;
        this.$refs.searchRoot.classList.remove('content-search--active');
        this.$refs.searchRoot.classList.remove('content-search--keep-open');
      } else {
        this.$refs.searchRoot.classList.add('content-search--keep-open');
      }
    },

    updateSearchValue(event) {
      this.searchValue = event.target.value;
    },

    toggleSearch() {
      if (this.keepOpenOnSearch && this.searchValue.trim() !== '') {
        this.$refs.searchRoot.classList.add('content-search--keep-open');
        this.$refs.searchInput.focus();
      } else {
        this.hideSearch();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$searchIconWidth: 31px;

.content-search {
  overflow: hidden;

  &--active {
    overflow: visible;
  }
}

.content-search__body {
  display: block;
  width: 100%;
}

.content-search__search-button {
  width: 20px;
  height: 20px;
  background: url(/images/icons/product-search.svg) no-repeat 0 50%;
  background-size: contain;
  cursor: pointer;
}

.content-search__input {
  flex: 1;
  border: none;
  font-weight: 500;
  color: $color--basic-white;
  outline: none;
  padding-left: calc(#{$searchIconWidth} + 20px);
  padding-right: 0;
  line-height: 30px;
  background-color: transparent;
  border-radius: 0;
  font-size: 19px;
  width: 100%;
  font-family: inherit;

  &::placeholder {
    color: $color--basic-white;
  }

}

.content-search__wrapper {
  display: flex;
  flex-direction: initial;
  align-items: center;
  width: initial;
  height: initial;
  transform: translateX(100%) translateX(-$searchIconWidth);
  background: url(/images/icons/product-search.svg) no-repeat 0 50%;
  position: relative;
  padding: 0;
  transition: transform .2s ease-out;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: $searchIconWidth;
    width: calc(100% - #{$searchIconWidth});
    height: 0;
    border-bottom: 2px solid $color--basic-dark-gray;
  }

  &:focus-within {
    transform: translateX(0);
  }
}

.content-search__search-button {
  display: none;
}

.content-search--keep-open {
  .content-search__wrapper {
    transform: translateX(0);
  }
}
</style>
